import type { ReactNode } from 'react';
import { NavLink } from 'react-router-dom';
import { ProvaliaLogo } from '../../shared/brand';
import { ThemeSelect } from '../../shared/ui';
import { Icon, type IconName } from './Icons';

const NAV: Array<{ to: string; label: string; icon: IconName; end?: boolean }> = [
  { to: '/', label: 'Resumen', icon: 'home', end: true },
  { to: '/clientes', label: 'Clientes', icon: 'clients' },
  { to: '/registro', label: 'Registro', icon: 'log' },
];

export function Layout({ userName, onLogout, children }: { userName: string | null; onLogout: () => void; children: ReactNode }): JSX.Element {
  return (
    <div className="shell admin-shell">
      <aside className="side">
        <div className="brand">
          <ProvaliaLogo sub="Administración" tone="white" />
        </div>
        <nav aria-label="Secciones del panel">
          {NAV.map((item) => (
            <NavLink key={item.to} to={item.to} end={item.end} className={({ isActive }) => (isActive ? 'active' : '')}>
              <Icon name={item.icon} />
              {item.label}
            </NavLink>
          ))}
        </nav>
        <div className="foot side-foot">
          <div className="side-user">
            <span className="side-avatar" aria-hidden="true">
              {(userName ?? 'E').slice(0, 1).toUpperCase()}
            </span>
            <span className="grow">
              <span className="side-user-name">{userName ?? 'Administrador'}</span>
              <span className="side-user-role">ECINSA</span>
            </span>
          </div>
          <ThemeSelect className="side-theme" />
          <button className="btn sm side-logout" onClick={onLogout}>
            <Icon name="logout" size={14} /> Salir
          </button>
        </div>
      </aside>
      <main className="main">
        <div className="admin-container">{children}</div>
      </main>
    </div>
  );
}
